import { Link } from 'react-router-dom';
import { fa_date } from '../../../../utils/PersianNum';
import { useGetSiteBlogQuery } from '../../../../Redux/Apis/blogApi';

function LastBlog({name,site_id}) {
	const {data , isLoading } = useGetSiteBlogQuery(site_id)

    return ( 
        <div className="blog-section">
			<div className="container">
				<div className="row mb-5">
					<div className="col-md-6">
						<h2 className="section-title">{name}</h2>
					</div>
					<div className="col-md-6 text-start">
						<Link to="/blog" className="more">مشاهده همه پست ها</Link>
					</div>
				</div>

				<div className="row">
					{ 
					isLoading ? "در حال بارگذاری" :
					data && data.map((row,index) => 
					<div className="col-12 col-sm-6 col-md-4 mb-4 mb-md-0" key={index}>
						<div className="post-entry">
							<Link to={`/post/${row.id}`} className="post-thumbnail"><img src={row.image} alt="thumbnail" className="img-fluid"/></Link>
							<div className="post-content-entry">
								<h3><Link to={`/post/${row.id}`}>{row.title}</Link></h3>
								<div className="meta">
									<span>در تاریخ {fa_date(row.create_date)}</span>
								</div>
							</div>
						</div>
					</div>
					)}
				</div>
			</div>
		</div>
    );
}

export default LastBlog;